import { ICourse } from '../../../interfaces';

export const initialContext = {
    course: null,
    loading: false,
    error: null,
    fetchCourse: () => {},
};
